import {
  DataTablePrimeReact,
  IColumnProps,
  PaginationERP,
  TableERP,
} from "@finanedi.es/storybook"
import { GetDocumentosComercialesImportadosByFiltersDtoProps } from "api/DTOs/GetDocumentosComercialesImportadosByFiltersDto"
import { AntdPaginationProps } from "api/interfaces/AntdPagination"
import { PAGINATION_STYLES } from "constants/primereactStyles"
import { Dispatch, RefObject, SetStateAction } from "react"
import { useTranslation } from "react-i18next"

export interface OCRTableProps {
  columns: IColumnProps[]
  dtRef: RefObject<
    DataTablePrimeReact<GetDocumentosComercialesImportadosByFiltersDtoProps[]>
  >
  items: Array<GetDocumentosComercialesImportadosByFiltersDtoProps>
  loading: boolean
  totalCount: number
  pagination: { itemsPerPage: number; skipCount: number }
  setPagination: Dispatch<SetStateAction<AntdPaginationProps>>
  handleOnRow: ({
    data,
  }: {
    data: GetDocumentosComercialesImportadosByFiltersDtoProps
  }) => void
  sortField: string | undefined
  sortOrder: 1 | 0 | -1 | null | undefined
  onSort: (e: {
    sortField: string | undefined
    sortOrder: 1 | 0 | -1 | null | undefined
  }) => void
}

const OCRTable = ({
  columns,
  dtRef,
  items,
  loading,
  totalCount,
  pagination,
  setPagination,
  handleOnRow,
  sortField,
  sortOrder,
  onSort,
}: OCRTableProps) => {
  const { t } = useTranslation()

  return (
    <div className='tw-flex tw-flex-col tw-flex-1 tw-relative tw-h-[calc(100dvh-340px)]'>
      <div className='tw-h-[calc(100%-60px)]'>
        <TableERP
          refTable={dtRef}
          columns={columns}
          className='tw-h-full'
          columnResizeMode='expand'
          data-testid='tabla-ocr'
          id='tabla-ocr'
          sortField={sortField}
          sortOrder={sortOrder}
          onSort={onSort}
          removableSort
          value={items}
          showGridlines
          dataKey='id'
          lazy
          scrollable
          onRowClick={handleOnRow}
          size='small'
          loading={loading}
          emptyMessage={t("primeReact.table.emptyMessage")}
        />
      </div>
      <PaginationERP
        className={PAGINATION_STYLES}
        totalRecords={totalCount}
        first={pagination.skipCount}
        rows={pagination.itemsPerPage}
        resetScroll={() => dtRef.current && dtRef.current?.resetScroll()}
        setPagination={setPagination}
        optionDropdown={[10, 20, 50, 100]}
        texts={{
          textRowsPerPageDropdown: `${t("pagination.textRowsPag")}`,
          textCurrentPageReport: `${t("pagination.from")}`,
        }}
      />
    </div>
  )
}

export default OCRTable
